import sh24 from './sh24'

export default sh24
